import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import Loader from "./components/utility/loader";
import {get_route_path} from "./constants/routes";

const WebApp = lazy(() => import("apps/web_app/app"));
// const CarrierApp = lazy(() => import("containers/CarrierApp/App"));
const CarrierApp = lazy(() => import("apps/carrier_app/app"));
const ShippingApp = lazy(() => import("apps/shipper_app/app"));
const AdminApp = lazy(() => import("apps/admin_app/app"));
const CarrierMobileApp = lazy(() => import("apps/carrier_mobile_app/app"));
const DevApp = lazy(() => import("apps/site_app/app"));

const PublicRoutes = ({ history, isLoggedIn }) => {
  return (
    // <ConnectedRouter history={history}>
      <BrowserRouter>
        <Suspense fallback={Loader}>
            <Routes>
              <Route
                  path={`${get_route_path("carrier", "app")}/*`}
                  element={<CarrierApp/>}
              />

              <Route
                  path={`/mobile_app/*`}
                  element={<CarrierMobileApp/>}
              />

              <Route
                  path={`/shipping/*`}
                  element={<ShippingApp/>}
              />
              <Route
                path={`/admin/*`}
                element={<AdminApp/>}
              />
              <Route
                path={`/dev/*`}
                element={<DevApp/>}
              />
              {/*<Route*/}
              {/*    path={get_route_path("admin", "app")}*/}
              {/*    component={AdminApp}*/}
              {/*/>*/}
              {/*<Route*/}
              {/*  exact*/}
              {/*  path={SITE_ROUTES["404"]}*/}
              {/*  component={asyncComponent(() => import("containers/SitePages/404"))}*/}
              {/*/>*/}
              {/*<Route*/}
              {/*  exact*/}
              {/*  path={SITE_ROUTES["500"]}*/}
              {/*  component={asyncComponent(() => import("containers/SitePages/500"))}*/}
              {/*/>*/}
              <Route
                  exact={true}
                  path='/'
                  element={<DevApp/>}
              />
              <Route
                  path="/:locale_path/*"
                  element={<DevApp/>}
              />
            {/*<Route*/}
            {/*    path="/:locale_path(fr_fr)/*"*/}
            {/*    element={<WebApp/>}*/}
            {/*/>*/}
              {/*<Route*/}
              {/*    path="/:locale_path(fr_ca)"*/}
              {/*    component={WebApp}*/}
              {/*    // component={(props) =>  <WebApp {... props}/>}*/}
              {/*/>*/}
            </Routes>
        </Suspense>
      </BrowserRouter>


 // </ConnectedRouter>
  );
};

export default connect(state => ({
  isLoggedIn: state.authUser != null
}))(PublicRoutes);
